import { render, staticRenderFns } from "./ticket_category_types.vue?vue&type=template&id=350f90c3&scoped=true&"
import script from "./ticket_category_types.vue?vue&type=script&lang=js&"
export * from "./ticket_category_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350f90c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('350f90c3')) {
      api.createRecord('350f90c3', component.options)
    } else {
      api.reload('350f90c3', component.options)
    }
    module.hot.accept("./ticket_category_types.vue?vue&type=template&id=350f90c3&scoped=true&", function () {
      api.rerender('350f90c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/ticket_category_types.vue"
export default component.exports